import { getPortalUrlFlat, isPathPortalEnvironment } from '../../utils/subdomain';
import { resolveBranchAdminHomePath } from '../../utils/branchRoutes';

/** Visual + auth rules per portal login surface. */
export const PORTAL_LOGIN_CONFIG = {
  admin: {
    theme: 'admin',
    requiredType: 'system_admin',
    typeError: 'هذه البوابة مخصصة لمدير النظام فقط',
    title: 'بوابة مدير النظام',
    subtitle: 'تسجيل الدخول إلى لوحة التحكم الرئيسية',
    fallbackIcon: '🛡️',
    needsCompany: false,
    resolvePostLogin: () => '/admin',
  },
  company: {
    theme: 'company',
    requiredType: null,
    typeError: null,
    title: (company, slug) => company?.name || slug || 'تسجيل الدخول',
    subtitle: 'تسجيل الدخول إلى لوحة التحكم',
    fallbackIcon: '🚚',
    needsCompany: true,
    resolvePostLogin: (user, hostCtx, slug) => {
      if (user.type === 'merchant') {
        if (hostCtx.portal === 'merchant') return '/';
        if (isPathPortalEnvironment()) return '/merchant';
        const url = slug && getPortalUrlFlat(slug, 'merchant');
        if (url) { window.location.href = url; return null; }
        return '/merchant';
      }
      if (user.type === 'rider') {
        if (hostCtx.portal === 'rider') return '/';
        if (isPathPortalEnvironment()) return '/rider';
        const url = slug && getPortalUrlFlat(slug, 'rider');
        if (url) { window.location.href = url; return null; }
        return '/rider';
      }
      if (user.type === 'system_admin') return '/admin';
      if (user.role === 'branch_admin') return resolveBranchAdminHomePath(user);
      return hostCtx.portal === 'company' ? '/' : '/';
    },
  },
  merchant: {
    theme: 'merchant',
    requiredType: 'merchant',
    typeError: 'هذه البوابة مخصصة للتجار فقط',
    title: (company, slug) => company?.name || slug || 'بوابة التاجر',
    subtitle: (company) => company?.merchant_app_name || 'بوابة التاجر',
    fallbackIcon: '🏪',
    logoField: 'merchant_app_logo_url',
    needsCompany: true,
    resolvePostLogin: (user, hostCtx, slug) => {
      if (hostCtx.portal === 'merchant') return '/';
      if (isPathPortalEnvironment()) return '/merchant';
      const url = slug && getPortalUrlFlat(slug, 'merchant');
      if (url) { window.location.href = url; return null; }
      return '/merchant';
    },
  },
  rider: {
    theme: 'rider',
    requiredType: 'rider',
    typeError: 'هذه البوابة مخصصة للمندوبين فقط',
    title: (company) => company?.rider_app_name || 'سريع',
    subtitle: (company, slug) => company?.name || slug || 'تطبيق المندوب',
    fallbackIcon: '🏍️',
    needsCompany: true,
    logoField: 'rider_app_logo_url',
    resolvePostLogin: (user, hostCtx, slug) => {
      if (hostCtx.portal === 'rider') return '/';
      if (isPathPortalEnvironment()) return '/rider';
      const url = slug && getPortalUrlFlat(slug, 'rider');
      if (url) { window.location.href = url; return null; }
      return '/';
    },
  },
};

export const PORTAL_THEMES = {
  admin: {
    page: { background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' },
    card: { boxShadow: '0 8px 32px rgba(0,0,0,0.3)' },
    titleColor: 'var(--color-primary)',
  },
  company: {
    page: (brandColor) => ({ backgroundColor: brandColor || 'var(--color-primary)', transition: 'background-color 0.3s ease' }),
    card: {},
    titleColor: (brandColor) => brandColor || 'var(--color-primary)',
  },
  merchant: {
    page: { background: 'linear-gradient(135deg, #EDE7F6 0%, #D4D0E0 50%, #3E2C6E 100%)' },
    card: {},
    titleColor: 'var(--color-primary)',
  },
  rider: {
    dark: true,
  },
};